
import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const JobDetailPage = lazy(() => import('../pages/job-detail/page'));
const JobsPage = lazy(() => import('../pages/jobs/page'));
const CommunityPage = lazy(() => import('../pages/community/page'));
const PostDetailPage = lazy(() => import('../pages/post-detail/page'));
const AuthPage = lazy(() => import('../pages/auth/page'));
const MyPage = lazy(() => import('../pages/mypage/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/jobs',
    element: <JobsPage />,
  },
  {
    path: '/job/:id',
    element: <JobDetailPage />,
  },
  {
    path: '/community',
    element: <CommunityPage />,
  },
  {
    path: '/community/:id',
    element: <PostDetailPage />,
  },
  {
    path: '/auth',
    element: <AuthPage />,
  },
  {
    path: '/mypage',
    element: <MyPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
